import { IRootState } from '../../../store'
import { IEmailDetail } from '../store/options.types'

export const getEmailDetailSelector = (state: IRootState): IEmailDetail | null | undefined =>
  state.options.patientDemographicsOptions.emailDetail
